import { cn } from "@responia/ui/lib/utils";

// La marque « la señal » : quatre barres, un niveau audio figé. Elle n'oscille que si
// l'assistant est VRAIMENT en ligne (état de santé réel, jamais une animation décorative).
export function Senal({ viva = false, className }: { viva?: boolean; className?: string }) {
  return (
    <svg
      className={cn("senal size-[1em]", viva && "viva", className)}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <rect x="3" y="9" width="3" height="6" rx="1.5" />
      <rect x="8.5" y="5" width="3" height="14" rx="1.5" />
      <rect x="14" y="7" width="3" height="10" rx="1.5" />
      <rect x="19.5" y="4" width="3" height="16" rx="1.5" />
    </svg>
  );
}
